/* eslint-disable no-unused-vars */
import "core-js/stable";
import "regenerator-runtime/runtime";
import ReactDOM from "react-dom/client";
import App from "./App";
import MaintenanceApp from "./MaintenanceApp";
import * as serviceWorker from "./serviceWorker";
import "./pollyfill/ie11Polyfill";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  window.location.href.includes("https://maintenance.phactmi.org") ? (
    <MaintenanceApp />
  ) : (
    <App />
  )
);

serviceWorker.unregister();